export default "__VITE_ASSET__DCrnpeKi__"